import { GBP_PROPERTIES, LOCATION_DATA_SOURCES } from 'constants/gbp';

/**
 * Construct oneline address from address components
 * @param {*} addressLines
 * @param {*} locality
 * @param {*} regionCode
 */
export const getOneLineAddress = (addressLines, locality, regionCode) => {
  let address = addressLines ? addressLines.join(', ') : '';
  address = address ? address.concat(', ', locality) : locality;
  return address.concat(', ', regionCode);
};

export const sectioningAddress = (address) => {
  var addrressArr = address.split(",");
  return addrressArr;
}

/**
 * Return CLDR formatted country code
 * ref: https://www.unicode.org/cldr/cldr-aux/charts/30/supplemental/territory_information.html
 * @param {String} country country eg: 'US', 'United States'
 * @returns {String} CLDR formatted country code
 */
export const extractCldrRegion = country => {
  const US = 'US', CA = 'CA';

  if (!country || !country.trim()) {
    return US;
  }

  const countryUpper = country.toUpperCase();
  switch (countryUpper) {
    case US:
    case 'USA':
    case 'UNITED STATES':
      return US;
    case CA:
    case 'CAN':
    case 'CANADA':
      return CA;
    default:
      return country;
  }
}

/**
 * Validate the property-value
 * @param {String} key property eg: 'PHONE_NUMBER'
 * @param {String} value value to validate eg: '0112729729'
 * @param {String} source source of the flow eg: GBP_EXISTING_LOCATION
 * @returns {Boolean} whether the property value is valid
 */
export const validateProperty = (key, value, source) => {
  switch (key) {
    case GBP_PROPERTIES.BUSINESS_TITLE:
      return !!value; // non-empty
    case GBP_PROPERTIES.CATEGORY:
    case GBP_PROPERTIES.PROFILE_DESCRIPTION:
      return source === LOCATION_DATA_SOURCES.MY_LOCATION || !!value;
    case GBP_PROPERTIES.PHONE_NUMBER:
      return !!value ? (/^(\+\d+)(?:\s*\d){9,10}$/).test(value) || (/^(?:\s*\d){10}$/).test(value) : false;
    default:
      return true;
  }
}

 /**
 * filter verification option details
 * @param {String} verificationMethod
 * @param {List} verificationOptionsData
 * @returns filtered verification option
 */
export const getVerificationOptionData = (verificationMethod, verificationOptionsData) => {
  return verificationOptionsData.filter((method) => method.get('verificationMethod') === verificationMethod);
};

 /**
 * check verification option is present in the option list
 * @param {String} verificationOption
 * @param {List} verificationOptionsList
 * @returns true if provided verification option is available, else false
 */
export const getVerificationOptionAvailability = (verificationOption, verificationOptionsList) => {
  return verificationOptionsList.some((method) => method.get('verificationMethod') === verificationOption);
};

 /**
 * get locationId from the data
 * @param {Map} data
 * @returns {String} location id
 */
 export const getLocationId = (data) => {
  return data.get('name').split("/")[1];
};